import React, {Component} from 'react'
import style from './_.module.css'
import PropTypes from "prop-types"
import {luiGetScrollbarWidth} from "../../utils/lui"


/**
 * @param { function() } props.onClosePressed
 * @param {*[]} children
 */
export default class LModal extends Component {

    static propTypes = {
        onClosePressed: PropTypes.func,
        children: PropTypes.node.isRequired
    }

    static #cfg = {
        zIndex: 200000,
        className: '_LModal_'
    }

    /**
     * @param { function() } props.onClosePressed
     * @param {*[]} props.children
     */
    constructor(props){
        super(props)
        LModal.#cfg.zIndex++
    }


    componentDidMount(){
        const scrollbarWidth = luiGetScrollbarWidth()
        document.body.style.paddingRight = `${scrollbarWidth}px`
        document.body.classList.add(style.noScroll)
        window.addEventListener('keydown', this.#handleKeyDown)
    }


    componentWillUnmount(){
        document.body.style.paddingRight = ''
        document.body.classList.remove(style.noScroll)
        window.removeEventListener('keydown', this.#handleKeyDown)
    }


    #closeHandler = (e) => {
        this.props.onClosePressed?.()
    }


    #handleKeyDown = (e) => {
        if (e.key === 'Escape') this.#closeHandler()
    }


    render() {
        const { children } = this.props
        const {zIndex, className} = LModal.#cfg

        return (
            <div
                className={className+' '+ style.overlay}
                style={{ zIndex: zIndex }}
                onClick={this.#closeHandler}
            >
                <div className={style.content} onClick={e => e.stopPropagation()}>
                    <button className={style.close} onClick={this.#closeHandler}>&times;</button>
                    {children}
                </div>
            </div>
        )
    }

}
